import apiClient from './api-client';

const post = endpoint => data => apiClient.post(endpoint, data);

export const logout_user = async data => {
  try {
    const response = await apiClient.post('logout_user', data);
    return response.data;
  } catch (error) {
    console.error('Logout error:', error);
    throw error;
  }
};

export const SendTwoFactor = () => apiClient.post('change_2fa_status', '');
export const getUserInfo = () => apiClient.get('user_info');
export const uploadProfile = post('uploadProfile');
export const verifyTFA = post('verifyTFAEmail');
export const verifyTFAEmail = post('verifyTFAEmail');
export const verifyGoogleAuth = post('verifyGoogleAuth');
export const tfaEnable = () => apiClient.get('TFAEnable');
export const tfaDisable = () => apiClient.get('TFADisable');
export const create = () => apiClient.get('create');
export const getUserInfo1 = post('user_infoEmail');
export const getUserWalletsAndEmail = post('getUserWalletsAndEmail');
export const login = post('login');
export const login1 = post('login');
export const verifyTwoFactor1 = post('varify_2fa_otp');
export const sendOtpGeneral = post('sendOtpGeneral');
export const sendOtpDynamic = post('sendOtpDynamic');
export const resendOtpGeneral = post('resendOtpGeneral');
export const varifyOtpGeneral = post('varifyOtpGeneral');
